module.exports = __webpack_public_path__ + "static/media/map-meise.8967fffc.png";